import React, { useMemo, useState } from 'react';
import cn from 'classnames';
// import ShareModalComponent from './UI/ShareButtonModal';

const Navbar = ({ project, mobileview, categoryRelease, consultancy, secretLinkToShare, proPlatformAccount }) => {
  // const [shareModalVisible, setShareModalVisible] = useState(false);

  const links = useMemo(
    () => {
      const isMoodboard = window.location.href.match('moodboard');
      return [
        {
          label: 'Project details & design brief',
          link: `/projects/${project.id}`,
          active: !isMoodboard,
        },
        {
          label: categoryRelease ? 'Design in progress' : 'Final design',
          link: `/projects/${project.id}/moodboard`,
          active: isMoodboard,
        },
      ];
    },
    [project.id],
  );

  const handleOnShare = () => {
    // setShareModalVisible(true);
    const element = document.getElementById('share-project-modal');
    if (element) {
      element.classList.add('-open');
    }
  };

  return (
    <div className={cn('navbar_container', { '-mobile': mobileview, '-dpp': proPlatformAccount })}>
      <div className="nav project-nav">
        {links.map(link => (
          <a
            key={link.link}
            className={cn('project-nav_item', { '-active': link.active })}
            href={link.link}
          >
            {link.label}
          </a>
        ))}
      </div>
      {/*{!proPlatformAccount && (*/}
      {/*  <div onClick={handleOnShare} className="nav_share_button project_share_button">*/}
      {/*    Share my design*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*<ShareModalComponent*/}
      {/*  visible={shareModalVisible}*/}
      {/*  secretLinkToShare={secretLinkToShare}*/}
      {/*  buttonClose={() => {*/}
      {/*    setShareModalVisible(false);*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  );
};

export default Navbar;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/Navbar.js